var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutitem-container",style:(_vm.containerBg)},[_c('title-item',{attrs:{"title":_vm.titleList[2]}}),_c('div',{staticClass:"txt"},[_vm._v(_vm._s(_vm.txtDiscription))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }